"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONNECT_AGAIN_COPY = exports.CONNECTION_ENDED_BODY_COPY = exports.CONNECTION_ENDED_BADGE_COPY = void 0;
/**
 * FP-175 (mobile's Android walk, 2026-10-07; shape approved by Paul, 2026-10-08): a bank
 * connection Plaid no longer has (ITEM_NOT_FOUND / INVALID_ACCESS_TOKEN, e.g. revoked in
 * Plaid's portal). Update-mode Reconnect cannot repair it (sandbox, report -95), so the
 * way back is a fresh connect, which supersedes the ended item and carries its goals and
 * debts (FP-109). Both clients show these; `*_COPY` names keep them in the inventory.
 */
exports.CONNECTION_ENDED_BADGE_COPY = "Connection ended";
exports.CONNECTION_ENDED_BODY_COPY = "This connection has ended, so it can't update or be repaired. Your history stays here. Connect this bank again to keep it up to date.";
exports.CONNECT_AGAIN_COPY = "Connect again";
//# sourceMappingURL=connectionEndedCopy.js.map